import { createFileRoute } from '@tanstack/react-router';
import { JourneysWorkflowHandoff } from '@/pages/workspaces/automations/[campaignId]/workflow/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateWorkflowCanvasSearch } from './-workflow-canvas-search';

/**
 * The state-agnostic `/journeys/campaigns/:campaignId/workflow` URL. Flag off it renders the
 * embedded host, which redirects to the setup or overview address by campaign state. Flag on it
 * forwards to the migrated URL, which serves campaigns in every state.
 *
 * `appBundle` belongs here for the same reason as on the setup URL: this URL keeps the
 * `journeys` segment the sentinel resolver rebuilds targets from.
 */
function JourneysCampaignsWorkflowRoute() {
  const { campaignId } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWorkflowHandoff campaignId={campaignId} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/workflow')(
  {
    component: JourneysCampaignsWorkflowRoute,
    validateSearch: validateWorkflowCanvasSearch,
  },
);
